// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071806/js/" + chunkId + "." + {"44":"22a59b34","225":"7cd9bde4","481":"319a431a","486":"c03c8fa3","770":"805c30cd"}[chunkId] + ".0.3286502413505359.chunk.js";
};